export default {
  'projectsList.pageHeader.title': 'Projects',
  'projectsList.pageHeader.createProjectButton': 'Create project',

  'projectsList.columnHeader.name': 'Name',
  'projectsList.columnHeader.status': 'Status',
  'projectsList.columnHeader.organization': 'Organization',
  'projectsList.columnHeader.dataset': 'Data set',
  'projectsList.columnHeader.visibility': 'Visibility',
  'projectsList.columnHeader.modifiedOn': 'Last modified',

  'projectsList.visibility.disabled': 'Disabled',
  'projectsList.visibility.enabled': 'Enabled',

  'projectsList.createProjectModal.title': 'Create project',

  'projectsList.createProjectModal.saveButton': 'Create project',
  'projectsList.createProjectModal.cancelButton': 'Cancel',
  'projectsList.createProjectModal.submitting': 'Creating project',
  'projectsList.createProjectModal.submittingError': 'Error submitting',
  'projectsList.createProjectModal.closeButton': 'Close',
  'projectsList.createProjectModal.success.title': 'Success',
  'projectsList.createProjectModal.success.text': '"{projectName}" was created successfully.',

  'projectsList.createProjectModal.projectName.label': 'Project name',
  'projectsList.createProjectModal.projectName.placeholder': 'Enter a project name',
  'projectsList.createProjectModal.dataset.label': 'Data set',
  'projectsList.createProjectModal.dataset.placeholder': 'Select a data set',
  'projectsList.createProjectModal.organization.label': 'Organization',
  'projectsList.createProjectModal.organization.placeholder': 'Select an organization',
  'projectsList.createProjectModal.visibility.label': 'Visibility',
  'projectsList.createProjectModal.visibility.enabled': 'Enabled',
  'projectsList.createProjectModal.visibility.disabled': 'Disabled',

  'projectsList.deleteProjectModal.title': 'Delete project',
  'projectsList.deleteProjectModal.confirmTitle': 'Confirm delete',
  'projectsList.deleteProjectModal.description': 'This action will permanently delete {projectId}.',
  'projectsList.deleteProjectModal.deleteButton': 'Delete project',
  'projectsList.deleteProjectModal.deletingButton': 'Deleting project',
  'projectsList.deleteProjectModal.cancelButton': 'Cancel',
  'projectsList.deleteProjectModal.submitting': 'Deleting project',
  'projectsList.deleteProjectModal.submittingError': 'Error submitting',
  'projectsList.deleteProjectModal.closeButton': 'Close',
  'projectsList.deleteProjectModal.actionUndone': 'This action cannot be undone.',
  'projectsList.deleteProjectModal.deleteCohorts':
    'This project has {count, plural, one {# cohort} other {# cohorts}}. Please delete {count, plural, one {that} other {them}} first and then try deleting project.',
  'projectsList.deleteProjectModal.success.title': 'Success',
  'projectsList.deleteProjectModal.success.text': '"{projectName}" was deleted successfully.',

  'projectsList.datagrid.noRows': 'No projects available. Create a project to get started.',
  'projectsList.datagrid.noResults': 'No projects available.',
  'projectsList.datagrid.errorMessage': 'An error occurred while fetching projects.',
  'projectsList.actionMenu.delete.label': 'Delete project',

  'projectsList.datasetModal.title': 'Data set details',
  'projectsList.datasetModal.noDatasets': 'No datasets details available.',
  'projectsList.datasetModal.releaseDate': 'Release date',
  'projectsList.datasetModal.dateRange': 'Date range',
  'projectsList.datasetModal.patientCount': 'Patient count',
  'projectsList.datasetModal.dataTypes': 'Data types',
};
